import type { ReactNode } from "react";
import { BackButton } from "./BackButton.tsx";

interface ScreenHeaderProps {
  title: ReactNode;
  onBack: () => void;
  /** Başlığın altında küçük bağlam satırı (gün, seri, rakip…). */
  subtitle?: string;
  actions?: ReactNode;
}

export function ScreenHeader({ title, subtitle, onBack, actions }: ScreenHeaderProps) {
  return (
    <header className="flex items-center gap-2.5 px-3.5 py-3">
      <BackButton onClick={onBack} />
      <div className="min-w-0 flex-1">
        <div className="scoreboard text-[1.125rem]">{title}</div>
        {subtitle && <div className="truncate text-xs text-muted">{subtitle}</div>}
      </div>
      {actions}
    </header>
  );
}
